var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('div',{ref:"financeMonthlyIncChart",staticStyle:{"height":"200px","width":"1000px"},attrs:{"id":"financeMonthlyIncChart"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }